// SSR proxy 回傳完整後端 envelope；這裡統一拆封：
// 成功回 data，業務錯誤把 error_code 丟成 Error（message=error_code，
// UI 可用 i18n `api.{error_code}` 翻譯），網路錯誤由 $fetch 自然 reject。
async function postSSR(path: string, body: Record<string, any>): Promise<any> {
  const res: any = await $fetch(path, { method: 'POST', body })
  if (res?.error_code === '00000') {
    return res.data
  }
  throw new Error(res?.error_code || 'UNKNOWN')
}

// 會員註冊 SSR
export async function registerSSR(account: string, password: string, name: string): Promise<any> {
  return await postSSR('/api/auth/register', { account, password, name })
}

// 會員登入 SSR
export async function loginSSR(account: string, password: string): Promise<any> {
  return await postSSR('/api/auth/login', { account, password })
}

// Google 登入驗證 SSR
export async function googleAuthenticateSSR(code: string, state: string): Promise<any> {
  return await postSSR('/api/auth/google-authenticate', { code, state })
}

// 會員登出 SSR
export async function logoutSSR(account: string): Promise<any> {
  return await postSSR('/api/auth/logout', { account })
}
